// Il gruppo di un tipo in Strumenti e in Provider (tela «PopTown Pop Style», artboard Strumenti e
// Provider): un accordion con l'icona nella tinta del tipo, il nome, il riepilogo e il conteggio;
// dentro, le schede delle singole connessioni o dei singoli account. Richiesta dell'utente del
// 2026-11-01: «se faccio 10 strumenti API messi tutti sullo stesso accordion», «anche lì va fatto».
import { useState } from 'react';
import type { ReactNode } from 'react';
import { Icon } from './Icon';

export type Tint = 'blue' | 'lilac' | 'pink' | 'coral' | 'mint' | 'sun';

export function KindGroup({
  title,
  summary,
  count,
  tint,
  icon,
  initial,
  children,
}: {
  title: string;
  summary: string;
  /** l'etichetta a destra: «3 connessioni», «2 account», «Sempre attivo» */
  count: string;
  tint: Tint;
  icon?: string;
  /** al posto dell'icona, l'iniziale (i provider) */
  initial?: string;
  children: ReactNode;
}) {
  const [open, setOpen] = useState(false);
  return (
    <section className="kind-group" data-tint={tint}>
      <button className="kind-head" aria-expanded={open} onClick={() => setOpen(!open)}>
        <span className="kind-icon" aria-hidden="true">
          {initial ?? <Icon name={icon ?? 'wrench'} size={24} />}
        </span>
        <span style={{ flex: '1 1 240px', minWidth: 0, display: 'grid', gap: 2 }}>
          <span className="kind-title">{title}</span>
          <span className="kind-summary">{summary}</span>
        </span>
        <span className="kind-count">{count}</span>
        <span className="kind-chevron" style={{ transform: open ? 'rotate(90deg)' : 'none' }}>
          <Icon name="chevron-right" size={22} />
        </span>
      </button>
      {open && <div className="kind-body">{children}</div>}
    </section>
  );
}

/** L'interruttore della tela, 56×32: menta quando è acceso. */
export function PopSwitch({
  checked,
  onChange,
  label,
  disabled,
}: {
  checked: boolean;
  onChange: (v: boolean) => void;
  label: string;
  disabled?: boolean;
}) {
  return (
    <button
      type="button"
      role="switch"
      className="pop-switch"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      onClick={() => onChange(!checked)}
    >
      <span />
    </button>
  );
}

/** Raggruppa per chiave mantenendo l'ordine della prima comparsa. */
export function groupBy<T>(items: T[], key: (item: T) => string): [string, T[]][] {
  const out = new Map<string, T[]>();
  for (const it of items) {
    const k = key(it);
    out.set(k, [...(out.get(k) ?? []), it]);
  }
  return [...out.entries()];
}
